// import axios from "axios";
import ky from "ky";
// import { ToastProgrammatic as Toast } from "buefy";
import store from "@/store";
// import router from "@/router";
// import { AUTH_LOGOUT } from "@/utils/action-types.js";

const defaultOptions = {
  throwHttpErrors: false,
  prefixUrl: `${
    process.env.VUE_APP_BASE_URL
      ? process.env.VUE_APP_BASE_URL
      : "reflective-learning-dashboard.ew.r.appspot.com"
  }/v1/`,
  timeout: 12 * 60 * 1000,
  hooks: {
    beforeRequest: [
      async options => {
        const jwtString = store.state.loginStore.jwtString;
        if (jwtString) {
          options.headers.set("Authorization", "Bearer " + jwtString);
        }
      }
    ]
    // afterResponse: [
    //   async response => {
    //     // handle universal errors
    //     if (!response.ok) {
    //       const responseBody = await response.json();
    //       switch (responseBody.code) {
    //         case "E_JWT_EXPIRED":
    //           Toast.open({
    //             message: "Your session has expired. Please log in.",
    //             type: "is-warning",
    //             duration: 4000
    //           });

    //           store.commit(AUTH_LOGOUT);
    //           router.push("/login");
    //       }
    //     }
    //   }
    // ]
  }
};

const apiClient = ky.extend(defaultOptions);

export default apiClient;
